<template>
	<div id="videoreview">
		<div class="lists" v-waterfall-lower="loadMore" waterfall-disabled="disabled" waterfall-offset="500">
		    <div class="list" v-for="(item,index) in reViewData" @click="onPlay(item.ds_id)" :key="index">
		    	<div class="img">
				 	<img :src="item.coverpic" class="stop" />
				</div>
			    <p class="title">{{item.name}}</p>
				<p>{{item.start_time}}</p>
		    </div>
		</div>
	</div>
</template>

<script>
import Vue from 'vue';
import tool from '../../../kits/Tools.js';
import vxxData from '../../../kits/data.js';
import { Toast } from 'vant';
import { Waterfall } from 'vant';

	export default {
		directives: {
			WaterfallLower: Waterfall('lower'),
			WaterfallUpper: Waterfall('upper'),
		},
		props:['mid','currentMid'],
		data(){
			return {
			  	reViewData:[],
			  	loaded:false,
			  	disabled:false,
			  	page_nums:10,
			  	page:1
			}
		},
		watch:{
			currentMid(){
				if(!this.loaded && this.currentMid == this.mid){
					this.onRefresh();
				}
			}
		},
        methods: {
        	loadMore(){
              this.onRefresh();
        	},
        	onRefresh(){

                if(this.disabled){
                    return;
                }
        		this.disabled = true;
            	var that = this;
            	Toast.loading({
					mask: true,
					message: '加载中...'
				});
				var params = 'mid='+this.mid+'&page='+this.page+"&page_nums="+this.page_nums;
            	this.axios.post(tool.baseUrl()+"/init/index/pastDs",params).then(function(data){
					Toast.clear();
	                if(data.data.code == "200") {
                       if(data.data.data.list.length>0){
                          that.reViewData = that.reViewData.concat(data.data.data.list);
	                      that.page++;
	                      that.disabled = false;
                       }
                       
	                    that.loaded = true;
	                }
	            }).catch(function(res){
	            	Toast(res.data.message)
	            }); 
        	},
        	onPlay(id){
        		vxxData.setInitData('');
        		location.href = "http://ph.shikee.tv/?ds_id="+id+"#/home/"
        		//location.href = "http://192.168.0.110:8081/?ds_id="+id+"#/home/"
        	}
        }
	}
</script>

<style scoped>

#videoreview{
	overflow: scroll;
}

.lists {
	height: 100%;
}

.list {
	width: 50%;
	padding: 5px;
	box-sizing: border-box;
	overflow: hidden;
	/* float: left; */
	display: inline-block;
	vertical-align: top;
}

.img {
	width: 100%;
	padding-bottom: 56.25%;
	position: relative;
	overflow: hidden;
}

.list img {
	width: 100%;
	position: absolute;
	top: 50%;
	left: 0;
	transform: translateY(-50%);
	height: 100%;
}

.title {
	height: 40px;
	overflow: hidden;
	margin: 5px 0;
	line-height: 20px;
}
</style>